import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import styles from "./Sidebar.module.scss";

interface SidebarProps {
    menus: { key: string; title: string; icon: React.ReactNode; items: { label: string; href: string, icon: React.ReactNode }[] }[];
    loading?: boolean;
}

const DownIcon = FaChevronDown as React.FC<{ size?: number; color?: string }>;

const Sidebar: React.FC<SidebarProps> = ({ menus, loading }) => {
    const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>(
        menus.reduce((acc, menu) => {
            acc[menu.key] = true; // abre todos por padrão
            return acc;
        }, {} as { [key: string]: boolean })
    );

    const [sidebarHeight, setSidebarHeight] = useState<number>(0);

    const toggleMenu = (key: string) => {
        setOpenMenus((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        const updateHeight = () => {
            const headerHeight = 75; // altura fixa do header
            const footerEl = document.querySelector("footer");
            let footerVisible = 0;

            if (footerEl) {
                const footerRect = footerEl.getBoundingClientRect();
                footerVisible = Math.max(0, window.innerHeight - footerRect.top);
            }

            setSidebarHeight(window.innerHeight - headerHeight - footerVisible);
        };

        updateHeight();
        window.addEventListener("resize", updateHeight);
        window.addEventListener("scroll", updateHeight);

        return () => {
            window.removeEventListener("resize", updateHeight);
            window.removeEventListener("scroll", updateHeight);
        };
    }, [loading]);

    return (
        <div className={styles.sidebar} style={{ height: sidebarHeight }}>
            <div className={styles.sidebarContent}>
                <ul className={styles.menuList}>
                    {menus.map((menu) => {
                        const isOpen = openMenus[menu.key];
                        return (
                            <li key={menu.key}>
                                <div
                                    onClick={() => toggleMenu(menu.key)}
                                    className={"sidebar-menu-title " + styles.menuTitle}
                                >
                                    <div className={styles.menuTitleContent}>
                                        {menu.icon}
                                        {menu.title}
                                        <DownIcon />
                                    </div>
                                </div>

                                <ul
                                    className={styles.subMenuList} style={{ maxHeight: isOpen ? menu.items.length * 40 : 0 }}
                                >
                                    {menu.items.map((item) => (
                                        <li key={item.href}>
                                            <Link
                                                to={item.href}
                                                className={"sidebar-subitem " + styles.subItem + (currentPath === item.href ? ` ${styles.active}` : "")}
                                            >
                                                {item.icon}
                                                {item.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default Sidebar;
